<div class="ai-pointer-events-blocker">
  <ng-template #dynamicHost></ng-template>
</div>
@if(showRelatedPathCta){
  <div>
    <button [state]="{ myData: dataToSend }" [routerLink]="relatedPathCtaLink"  [fragment]="relatedFragment">
      {{resourceStrings['Aon.Common.JumpToCorrespondingPage']}}
    </button>
  </div>
}

